export const NAME = 'schedule';
